export default "__VITE_ASSET__4f788763__"